import BaseServiceCrud from './BaseServiceCrud';

export default class SettingService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'ranks';
        this.getValue = this.getValue.bind(this);
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            name: criteria.name,
            locale: criteria.locale,
            level: criteria.level,
            rangeFrom: criteria.range_from,
            rangeTo: criteria.rangeTo,
            id: criteria.id,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    getValue(key) {
        return this.fetch(`${this.domain}/${this.path}/key/` + key, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }

    getCaptchaPublic() {
        return this.fetch(`${this.domain}/${this.path}/captcha`, {
            method: 'GET',
        })
            .then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }
    update(element) {
        return this.fetch(`${this.domain}/${this.path}/${element.id}`, {
            method: 'PUT',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    save(element) {
        return this.fetch(`${this.domain}/${this.path}/`, {
            method: 'POST',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    delete(ids) {
        const url = `${this.domain}/${this.path}/`;
        return this.fetch(`${url}`, {
            method: 'DELETE',
            body: JSON.stringify(ids),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
